import type { CmsSlot } from '@hubblecommerce/hubble/platforms/shopware/api-client'
import type {HblMedia, HblProduct, HblProductListing, HblSlot} from '@/utils/types'
import { hblMapMedia, hblMediaIncludes, hblMapProductListing, hblProductListingIncludes, hblMapProducts } from '#imports'

export const hblSlotIncludes = {
    'cms_slot': [
        'versionId',
        'blockId',
        'type',
        'slot',
        'data',
        'media',
        'config',
        'translated',
        'extensions',
        'swagCmsExtensionsForm',
    ],
    'swag_cms_extensions_form': [
        'id',
        'technicalName',
        'title',
        'successMessage',
        'receivers',
        'groups',
        'translated',
        'extensions',
        'lgCoreFormConfig',
    ],
    'lg_core_form_config': [
        'id',
        'submitButtonLabel',
    ],
    'swag_cms_extensions_form_group': [
        'id',
        'technicalName',
        'title',
        'fields',
        'translated',
    ],
    'swag_cms_extensions_form_group_field': [
        'id',
        'type',
        'technicalName',
        'width',
        'required',
        'label',
        'placeholder',
        'config',
        'translated',
    ],
    ...hblMediaIncludes,
    ...hblProductListingIncludes,
}

export function hblMapSlots (swSlots: CmsSlot[]): HblSlot[] {
    // @ts-ignore
    return swSlots.map((slot: CmsSlot) => {
        let productListing: HblProductListing | null = null
        let products: HblProduct[] | null = null
        let media: HblMedia | null = null

        if (slot.data?.listing != null) {
            productListing = hblMapProductListing(slot.data.listing)
        }

        if (slot.data?.products != null) {
            products = hblMapProducts(slot.data.products)
        }

        if (slot.data?.media != null) {
            media = hblMapMedia(slot.data.media)
        }

        return {
            id: slot.versionId,
            blockId: slot.blockId,
            type: slot.type,
            position: slot.slot,
            data: productListing != null || products != null ? null : slot.data,
            ...(productListing != null && { productListing }),
            ...(products != null && { products }),
            ...(media != null && { media }),
            ...(slot?.config != null && { config: slot.translated?.config }),
            // @ts-ignore
            ...(slot?.extensions != null && { extensions: slot.extensions })
        }
    })
}
